import React from 'react';
import SbEditable from 'storyblok-react';
import RelatedPosts from '~/components/Dynamic/RelatedPosts';
import useBlogPostPreviews from '~/hooks/useBlogPostPreviews';
export default function LatestBlogPosts({ blok }) {
  const postPreviews = useBlogPostPreviews();
  return (
    <SbEditable content={blok}>
      <div className="container my-20 border-t border-black md:my-28 opacity-10"></div>
      <RelatedPosts heading={blok?.textCard[0]?.heading} posts={postPreviews.slice(0, 3)} />
    </SbEditable>
  );
}
